import {
    isFlightEntity,
    isEntityContainsLodging,
    isRentalEntity,
    isPackageEntity,
    isDiningEntity,
    isEventEntity,
    isInvoiceEntity,
    isUnsuccessfulFlightEntity,
    isUnsuccessfulLodgingEntity,
    isUnsuccessfulRentalEntity,
} from '../view/entityCheckHelpers';
import EntityTypeNames from 'txp-data/lib/schema/innerSchema/EntityTypeNames';

/**
 * Returns a string containing entity names(comma separated)
 * It is computed based on which entity bits are set in the input entityNamesMap
 */
export default function getEntityStringFromEntityNamesMap(entityNamesMap: number): string {
    let entities = [];

    isFlightEntity(entityNamesMap) && entities.push(EntityTypeNames.FlightReservation);

    isEntityContainsLodging(entityNamesMap) && entities.push(EntityTypeNames.LodgingReservation);

    isRentalEntity(entityNamesMap) && entities.push(EntityTypeNames.RentalCarReservation);

    isPackageEntity(entityNamesMap) && entities.push(EntityTypeNames.ParcelDelivery);

    isDiningEntity(entityNamesMap) && entities.push(EntityTypeNames.FoodReservation);

    isEventEntity(entityNamesMap) && entities.push(EntityTypeNames.EventReservation);

    isInvoiceEntity(entityNamesMap) && entities.push(EntityTypeNames.Invoice);

    isUnsuccessfulFlightEntity(entityNamesMap) &&
        entities.push(EntityTypeNames.UnsuccessfulFlightReservation);

    isUnsuccessfulLodgingEntity(entityNamesMap) &&
        entities.push(EntityTypeNames.UnsuccessfulLodgingReservation);

    isUnsuccessfulRentalEntity(entityNamesMap) &&
        entities.push(EntityTypeNames.UnsuccessfulRentalCarReservation);

    return entities.join(',');
}
